import React, { useEffect, useState } from 'react';

import { FormControl, Grid, IconButton, Paper, TextField, Typography } from '@mui/material';
import { Ingredient, Step } from '../../services/api/models';
import { DragDropContext, Droppable, DropResult, DroppableProps, Draggable } from 'react-beautiful-dnd'
import { useFieldArray, useFormContext } from 'react-hook-form';
import DeleteIcon from '@mui/icons-material/Delete';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import StepAddForm from '../StepAddForm';

const resetSort = (list: Array<Ingredient>) => {
  for (let i = 0; i < list.length; i++) {
    list[i].sort = i + 1
  }
}

export default function StepsEditor() {
  const { control, getValues, setValue, register } = useFormContext();
  const { fields, move, remove  } = useFieldArray({
    control,
    name: 'steps',
  });

  const onDragEnd = (result: DropResult) =>  {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }

    move(result.source.index, result.destination.index)

    const steps = getValues('steps');
    // update sort order
    resetSort(steps);
    setValue('steps', steps);
  }

  const onAddHandler = (step: Step) => {
    const steps = getValues('steps');
    const results = [...steps, step];
    step.sort = results.length;
    setValue('steps', results);
  };

  return (
    <Paper>
      <Typography variant="h2">Instructions</Typography>
        <DragDropContext onDragEnd={onDragEnd}>
        <StrictModeDroppable droppableId='list' direction='vertical'>
          {provided => (
            <Paper ref={provided.innerRef} {...provided.droppableProps}>
              {fields.map((step, index) => (
                <Draggable
                  draggableId={`step-${getValues(`steps.${index}.id`)}-${index}`}
                  index={index}
                  key={`step-${getValues(`steps.${index}.id`)}-${index}`}>
                {provided => (
                  <Grid container key={step.id} ref={provided.innerRef} {...provided.draggableProps}>
                    <Grid item {...provided.dragHandleProps}>
                      <DragIndicatorIcon/>
                    </Grid>
                    <Grid item xs={11}>
                      <FormControl>
                        <TextField id={`steps.${index}.name`} variant='outlined' size='small' {...register(`steps.${index}.name`)}/>
                      </FormControl>
                      <FormControl fullWidth>
                        <TextField multiline rows={4} id={`steps.${index}.text`} variant='outlined' size='small' {...register(`steps.${index}.text`)}/>
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <IconButton color="primary" aria-label="upload picture" component="span" size='small' sx={{align: 'right', display: 'flex'}} onClick={() => {remove(index)}}>
                        <DeleteIcon fontSize='small'/>
                      </IconButton>
                    </Grid>
                  </Grid>
                  )}
                </Draggable>
              ))}
            <StepAddForm onAdd={onAddHandler}/>
            </Paper>
          )}
          </StrictModeDroppable>
        </DragDropContext>
    </Paper>
  );
}


export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    const animation = requestAnimationFrame(() => setEnabled(true));
    return () => {
      cancelAnimationFrame(animation);
      setEnabled(false);
    };
  }, []);
  if (!enabled) {
    return null;
  }
  return <Droppable {...props}>{children}</Droppable>;
};
